import { DateFormatOptions, Timestamp } from '@griply/types';
import { format } from 'date-fns';

const fullDateFormats: Record<DateFormatOptions, string> = {
  [DateFormatOptions.DayMonthYear]: 'd MMM yyyy',
  [DateFormatOptions.MonthDayYear]: 'MMM d, yyyy',
};

export const formatFullDate = (
  date: Timestamp,
  dateFormat: DateFormatOptions,
) => format(date, fullDateFormats[dateFormat]);
